import { Tubing_Flow_Options_Enum } from "gql/api";
import type { BasicData, FluidFrictionProperties, FluidProperties } from "../d";
import { getFlowRegimeBeggsBrill } from "./getFlowRegime_BeggsBrill";
import { getFlowRegimeDunsRos } from "./getFlowRegime_DunsRos";
import { getFluidFrictionPrerequisites } from "./getFluidFrictionPrerequisites";
import { getFlowRegimeOrkiszewiski } from "./getFlowRegime_Orkiszewiski";

// These calcs are from /static/Friction Calcs foo.xlsx
export function getFluidFrictionProperties(
  basicData: BasicData,
  correlation: Tubing_Flow_Options_Enum,
  fluidProperties: FluidProperties,
  pipeDiameterIn: number,
  pumpIntakePressurePSIA: number
): FluidFrictionProperties {
  const fluidFrictionPrerequisites = getFluidFrictionPrerequisites(
    basicData,
    fluidProperties,
    pipeDiameterIn,
    pumpIntakePressurePSIA
  );

  let flowRegime;
  if (correlation === Tubing_Flow_Options_Enum.BeggsBrill) {
    flowRegime = getFlowRegimeBeggsBrill(fluidFrictionPrerequisites);
  } else if (correlation === Tubing_Flow_Options_Enum.DunsRos) {
    flowRegime = getFlowRegimeDunsRos(fluidFrictionPrerequisites);
  } else if (correlation === Tubing_Flow_Options_Enum.Orkiszewski) {
    flowRegime = getFlowRegimeOrkiszewiski(
      fluidFrictionPrerequisites,
      fluidProperties
    );
  } else {
    flowRegime = "N/A";
  }

  return {
    ...fluidFrictionPrerequisites,
    calcMethod: correlation,
    flowRegime
  };
}
